<template>
    <admin-dashboard-layout>
        <router-link
            :to="{name: 'admin.settings.create'}"
        >
            <v-btn
                color="black"
                large
            >
                <v-icon color="green">mdi-plus-outline</v-icon>
                <span>{{ $t('Add Setting') }}</span>
            </v-btn>
        </router-link>
        <v-data-table
            :loading="loading"
            loading-text="Loading... Please wait"
            :headers="headers"
            :items="settings"
            :items-per-page="30"
            class="elevation-1"
            @click:row="handleClickRow"
        >
            <template v-slot:item.created_at="{ item }">
                {{ item.created_at ? moment(item.created_at).format('LLL') : '' }}
            </template>
            <template v-slot:item.action="{ item }">
                <v-btn @click.stop="handleDeleteItem(item)">
                    <v-icon color="red">mdi-trash-can-outline</v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </admin-dashboard-layout>
</template>

<script>
import AdminDashboardLayout from "../../../layouts/AdminDashboardLayout";
import Settings from "@/models/admin/Settings";

export default {
    name: "settings-index",
    components: { AdminDashboardLayout },
    data: function () {
        return {
            loading: false,
            settings: [],
            headers: [
                {text: 'Key', value: 'key'},
                {text: 'Value', value: 'value'},
                {text: 'Action', value: 'action'},
            ],
        }
    },
    methods: {
        handleClickRow({id}) {
            this.$router.push({name: 'admin.settings.edit', params: {id}})
        },
        handleDeleteItem({id}) {
            this.loading = true
            Settings.find(id)
                .then(m => {
                    m.delete()
                    this.fetchSettings()
                }).finally(() => this.loading = false)
        },
        fetchSettings() {
            this.loading = true
            Settings
                .get()
                .then(settings => this.settings = settings)
                .catch((e) => console.log(e))
                .finally(() => this.loading = false)
        }
    },
    created() {
        this.fetchSettings()
    },
}
</script>